<template>
  <div>
    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5 v-html="$store.getters.getTag('2')"></h5>
      </legend>
    </div>

    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5 v-html="$store.getters.getTag('2.2')"></h5>
      </legend>
    </div>

    <form-v2-csa-scopes-table
      :activity="activity"
      v-if="activity && status"
      :disabled="disabled"
      :status="status"
      :title="$store.getters.getTag('2.2.1.T')"
      :subtitle="$store.getters.getTag('2.2.1.S')"
      :footer="$store.getters.getTag('2.2.1.F')"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },
    status() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.status.code
        : null;
    },
    disabled() {
      if (["100"].includes(this.status)) {
        return false;
      } else if (["112"].includes(this.status)) {
          if (this.$store.state.accreditation.app.change_scopes) {
            return false;
          } else {
            return true;
          } 
      } else {
        return true;
      }
    },
  },
  created() {
  },
  methods: {},
};
</script>
